angular.module('env.custom.customModule.attachmentsHelperService', [])
    .provider('attachmentsHelperService', function () {
        var helper = new AttachmentsHelper();
        this.getPrescriptionFileNameId = helper.getPrescriptionFileNameId;
        this.getLeftFootImageFileNameId = helper.getLeftFootImageFileNameId;
        this.getRightFootImageFileNameId = helper.getRightFootImageFileNameId;
        this.getLeftFootScanFileNameId = helper.getLeftFootScanFileNameId;
        this.getRightFootScanFileNameId = helper.getRightFootScanFileNameId;
        this.getOrderIdAndPatientNameString = helper.getOrderIdAndPatientNameString;

        this.$get = function () {
            return new AttachmentsHelper();
        };

        function AttachmentsHelper() {
            function getPatientName(dataItem) {
                if (dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.Patient) {
                    return dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.Patient.Name;
                }
                if (dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.PatientInfo) {
                    return dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.PatientInfo.PatientRef;
                }
                return null;
            }

            var _this = this;

            _this.getOrderIdAndPatientNameString = function (dataItem) {
                var patientName = getPatientName(dataItem);
                if (!patientName) {
                    return null;
                }
                return dataItem.$model.order.$model.id + '_' + patientName;
            };

            _this.getPrescriptionFileNameId = function (dataItem) {
                var orderIdAndPatient = _this.getOrderIdAndPatientNameString(dataItem);
                //Try the new file format first
                var fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_UserPrescription.pdf');
                if (!fileId) {
                    //we have an 'old format' file name, so use it instead
                    var translatedOrderType = dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.OrderType;
                    switch (dataItem.$model.order.$model.jsonData.OrderData.OrthoticsOrder.OrderType) {
                        case 'Initial':
                            translatedOrderType = 'OrderDetail';
                            break;
                        case 'SecondIdentical':
                            translatedOrderType = 'OrderDetail.SecondIdenticalOrder';
                            break;
                        case 'SecondIdenticalShellWithDifferentCover':
                            translatedOrderType = 'OrderDetail.SecondIdenticalOrderWithDifferentCover';
                            break;
                        case 'SecondNonIdentical':
                            translatedOrderType = 'OrderDetail.SecondNonIdenticalOrder';
                            break;
                        default:
                            translatedOrderType = 'OrderDetail';
                            break;
                    }

                    fileId = dataItem.getDocumentIdByFilename(
                        'Order#' + dataItem.$model.order.$model.id + '_' + translatedOrderType + '.pdf');
                }
                return fileId;
            };

            _this.getLeftFootImageFileNameId = function (dataItem) {
                var orderIdAndPatient = _this.getOrderIdAndPatientNameString(dataItem);
                var fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_LeftFootImage.jpg');
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename('LeftFootImage.jpg');
                }
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_left.jpg');
                }
                return fileId;
            };

            _this.getRightFootImageFileNameId = function (dataItem) {
                var orderIdAndPatient = _this.getOrderIdAndPatientNameString(dataItem);
                var fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_RightFootImage.jpg');
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename('RightFootImage.jpg');
                }
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_right.jpg');
                }
                return fileId;
            };

            _this.getLeftFootScanFileNameId = function (dataItem) {
                var orderIdAndPatient = _this.getOrderIdAndPatientNameString(dataItem);
                var fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_LeftFootScan.stl');
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename('LeftFootScan.stl');
                }
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_left.dmt');
                }
                return fileId;
            };

            _this.getRightFootScanFileNameId = function (dataItem) {
                var orderIdAndPatient = _this.getOrderIdAndPatientNameString(dataItem);
                var fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_RightFootScan.stl');
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename('RightFootScan.stl');
                }
                if (!fileId) {
                    fileId = dataItem.getDocumentIdByFilename(orderIdAndPatient + '_right.dmt');
                }
                return fileId;
            };
        }
    })
;
